import env from "@beam-australia/react-env";

export const perksEnabled = () => env("PERKS_ENABLED") === "true";
